import { GFSCodeContent } from "../../components/accounting";

export default function GFSCode() {
  return <GFSCodeContent />;
}
